import React, {FC} from 'react'
import {Box, Grid, IconButton, Tooltip, Typography} from '@mui/material'
import DeleteForever from '@mui/icons-material/DeleteForever'
import {ru} from 'date-fns/locale'
import {format} from 'date-fns'
import {VisibleIcon} from '@components/UI/Icons/VisibleIcon'
import {grey50} from '../../../../@theme/vars'
import TitleLink from '../../styled/TitleLink'
import {RELATED_PUBLICATIONS_CONSTS} from './RelatedPublicationItem.consts'
import {
  AuthorsTitle,
  FlexAuthors,
  FlexExtSettings,
  FlexPublicationInfo,
  FlexSettings,
  ItemWrapper,
  MainDiv,
  PublicationDateWrapper
} from './RelatedPublicationItem.styles'
import {RelatedPublicationItemProps} from './RelatedPublicationItemProps'

const RelatedPublicationItem: FC<RelatedPublicationItemProps> = ({publication, onRemove}) => {
  const handleOpenPublicationOnSite = () => {
    window.open(
      `${process.env.REACT_APP_URA_NEWS_URL + (publication.typeSlug as string)}/${publication.deprecatedId}`,
      '_blank'
    )
  }

  return (
    <ItemWrapper>
      <MainDiv>
        <FlexPublicationInfo>
          <TitleLink to={`/editor/${publication.uid}`}>
            <Typography variant='text16M'>{publication.title || RELATED_PUBLICATIONS_CONSTS.withoutName}</Typography>
          </TitleLink>
          <PublicationDateWrapper>
            <Typography variant='text12R' color={grey50}>
              {publication.publishedAt &&
                format(new Date(publication.publishedAt), 'dd MMMM yyyy HH:mm', {
                  locale: ru
                })}
            </Typography>
          </PublicationDateWrapper>
        </FlexPublicationInfo>
        <FlexExtSettings>
          <FlexSettings>
            <Tooltip title={RELATED_PUBLICATIONS_CONSTS.viewOnSiteMsg}>
              <IconButton size='small' onClick={handleOpenPublicationOnSite}>
                <VisibleIcon color='secondary' width={34} height={34} />
              </IconButton>
            </Tooltip>
            <Tooltip title={RELATED_PUBLICATIONS_CONSTS.deletePublicationFromStory}>
              <IconButton size='small' onClick={() => onRemove(publication.uid)}>
                <DeleteForever color='disabled' />
              </IconButton>
            </Tooltip>
          </FlexSettings>
          <FlexAuthors>
            {publication?.authors?.map(author => (
              <AuthorsTitle variant='text14R' key={publication.uid + author.uid}>
                {author.firstName} {author.lastName}
              </AuthorsTitle>
            ))}
          </FlexAuthors>
        </FlexExtSettings>
      </MainDiv>
    </ItemWrapper>
  )
}

export default RelatedPublicationItem
